import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.label`
  font-size: 1.4rem;
  margin-bottom: 2rem;

  span {
    margin-left: 1rem;

    a {
      color: inherit;
      font-weight: 600;
      text-decoration: underline;
    }
  }
  p {
    font-size: 1.3rem;
    margin-top: 1rem;
  }
`;

const Checkbox = ({
  checked,
  content,
  error,
  isRequired,
  name,
  onCheck,
}) => (
  <Wrapper for={name}>
    <input
      name={name}
      type="checkbox"
      checked={checked}
      onChange={() => onCheck(name)}
    />
    {content}{isRequired && '*'}
    {error && <p>This field is required</p>}
  </Wrapper>
);

Checkbox.propTypes = {
  checked: PropTypes.bool,
  content: PropTypes.string.isRequired,
  error: PropTypes.bool,
  isRequired: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onCheck: PropTypes.func.isRequired,
};

Checkbox.defaultProps = {
  checked: false,
  error: false,
  isRequired: false,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js